export enum NsaView {
  DASHBOARD = 1,
  EXPORT_IMPORT = 2,
}
